import { useApiQuery } from "@/lib/api/hooks";
import { useT } from "@/lib/i18n";
import { personHandle } from "./names";
import { PersonLink } from "./person-link";

/**
 * The person behind an approval / run target (a comment or a conversation), as a PersonLink. Reads the item's detail
 * (cached, shared with the quick panels); renders nothing until it is known or when the author is the account itself.
 */
export function TargetPerson({ type, id, className }: { type: "comment" | "conversation" | "bulk" | string; id: string | null; className?: string }) {
  const { t } = useT();
  const comment = useApiQuery("commentDetail", { params: { commentId: id ?? "" } }, { enabled: type === "comment" && !!id, staleTime: 60_000 });
  const conv = useApiQuery("conversation", { params: { conversationId: id ?? "" } }, { enabled: type === "conversation" && !!id, staleTime: 60_000 });
  if (type === "comment" && comment.data && !comment.data.comment.byAccount) {
    const a = comment.data.comment.author;
    return (
      <PersonLink contactId={a.contactId} username={a.username} className={className} testId="target-person">
        <span dir="ltr">&lrm;@{a.username}</span>
      </PersonLink>
    );
  }
  if (type === "conversation" && conv.data) {
    const c = conv.data.contact;
    return (
      <PersonLink contactId={c.id} className={className} testId="target-person">
        <span dir="ltr">&lrm;{personHandle(t, c.identities.find((i) => i.handle)?.handle, c.displayName)}</span>
      </PersonLink>
    );
  }
  return null;
}
